"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProfessionalBeautyStandardsHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.15);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="professional-beauty-standards-hero" className="relative w-full bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-secondary/30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 min-h-[85vh] items-center py-20 lg:py-24">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center pr-0 lg:pr-12 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary border border-border w-fit mb-8">
              <ShieldCheck className="w-4 h-4 text-primary" />
              <span className="text-xs font-medium tracking-wide text-secondary-foreground uppercase">
                Australian Registered Company
              </span>
            </div>

            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-foreground leading-[1.1] tracking-tight mb-8">
              Redefining Australian <br className="hidden sm:block" />
              <span className="text-muted-foreground italic">Beauty Standards</span>
            </h1>

            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed mb-10 max-w-2xl font-sans font-light">
              HSINHUI COSMETICS PTY LTD is committed to delivering high-quality product formulations that comply with rigorous Australian manufacturing standards. We provide a comprehensive range of skincare and beauty essentials designed for global markets.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <Button asChild size="lg" className="w-full sm:w-auto group h-14 px-8 text-base">
                <Link to="/ProductsPage">
                  Explore Collections
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base border-2">
                <Link to="/AboutUsPage">
                  Corporate Profile
                </Link>
              </Button>
            </div>
            
            <div className="mt-12 pt-8 border-t border-border flex items-center gap-8">
              <div>
                <p className="text-3xl font-serif text-foreground">2024</p>
                <p className="text-sm text-muted-foreground uppercase tracking-wider mt-1">Established</p>
              </div>
              <div className="w-px h-12 bg-border" />
              <div>
                <p className="text-3xl font-serif text-foreground">VIC</p>
                <p className="text-sm text-muted-foreground uppercase tracking-wider mt-1">Headquarters</p>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative h-[60vh] lg:h-[80vh] w-full rounded-2xl overflow-hidden transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute inset-0 bg-secondary/20 mix-blend-multiply z-10" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594097/img/premium_skincare_bottle_stone.png" alt="Premium skincare glass bottle on neutral stone background" className="absolute inset-0 w-full h-[120%] object-cover object-center will-change-transform" style={{
            transform: `translateY(-${offsetY * 0.5}px)`,
            transition: 'transform 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          }} />
            
            {}
            <div className="absolute bottom-8 left-8 right-8 bg-background/80 backdrop-blur-md border border-white/20 p-6 rounded-xl z-20 shadow-xl">
              <p className="text-sm font-medium text-foreground mb-1">Clinical Precision</p>
              <p className="text-xs text-muted-foreground">Formulated under strict Australian guidelines.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}